import React from "react";

const Banner = () => {
  return (
    <section className="bg-white text-black py-24 px-6 text-center">

      <h1 className="text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent">
        Premium Sports Turf Construction
      </h1>

      <p className="text-lg md:text-xl mb-8 text-gray-700 max-w-2xl mx-auto mt-4">
        Trusted across India for building world-class football turfs, box cricket arenas, and multi-sport surfaces.
      </p>

      <div className="flex justify-center gap-4">
        <button
          className="bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow hover:bg-green-700 transition duration-300"
        >
          Get Quote
        </button>

        <button
          className="border border-green-600 text-green-600 font-semibold py-3 px-6 rounded-lg shadow hover:bg-green-600 hover:text-white transition duration-300"
        >
          View Projects
        </button>
      </div>

    </section>
  );
};

export default Banner;
